import React from 'react';
export var LargeWarningStatusIcon = function () { return (React.createElement("svg", { viewBox: "0 0 32 32" },
    React.createElement("path", { fill: "#f2c973", d: "M32 32H0L16 0z" }),
    React.createElement("path", { fill: "#444444", d: "M14 12h4v10h-4zm0 12h4v4h-4z" }))); };
//# sourceMappingURL=LargeWarningStatusIcon.js.map